<template>
  <section id="banner">
    <div class="inner">
      <header>
        <h2>Create URL</h2>
      </header>
      <p>
        <input v-model="longUrl" type="text" placeholder="Paste your long URL here">
      </p>
      <p v-if="!advancedInput" class="input-mode">
        <a v-on:click="advancedInputModeToggle">more <i class="fa fa-caret-down"></i></a>
      </p>
      <p v-if="advancedInput">
        <input v-model="shortName" type="text" placeholder="Type a short name">
      </p>
      <p v-if="advancedInput" class="input-mode">
        <a v-on:click="advancedInputModeToggle">less <i class="fa fa-caret-up"></i></a>
      </p>
      <footer>
        <ul class="buttons stacked">
          <li v-if="hasError">
            <strong v-if="errorMessage"><i class="fa fa-exclamation-triangle"></i> {{ errorMessage }}</strong>
            <strong v-else><i class="fa fa-exclamation-triangle"></i> an error occured</strong>
          </li>
          <li v-if="shortUrl">Your URL is now: <a v-bind:href="shortUrl">{{ shortUrl }}</a></li>
          <li v-if="shortUrl"><a class="button fit" v-on:click="reset">Generate another</a></li>
          <li v-else>
            <a class="button fit" v-if="isProcessing"><i class="fa fa-spinner fa-spin"></i></a>
            <a class="button fit" v-else v-on:click="shrinkUrl">Shrink it !</a>
          </li>
        </ul>
      </footer>
    </div>
  </section>
</template>

<script>
import CloudEndpointService from '../services/cloud-endpoint'

const cloudEndpoint = new CloudEndpointService()

export default {
  name: 'CreateUrl',
  data: function () {
    return {
      longUrl: '',
      shortUrl: null,
      shortName: null,
      isProcessing: false,
      advancedInput: false,
      hasError: false,
      errorMessage: null
    }
  },
  methods: {
    reset: function () {
      this.longUrl = ''
      this.shortUrl = null
      this.shortName = null
      this.isProcessing = false
      this.advancedInput = false
      this.hasError = false
      this.errorMessage = null
    },
    advancedInputModeToggle: function () {
      this.advancedInput = !this.advancedInput
    },
    shrinkUrl: function () {
      let that = this
      let shortUrlEndpoint = process.env.SHORT_URL_ENDPOINT

      that.isProcessing = true
      that.shortUrl = null
      that.hasError = false
      that.errorMessage = null

      if (that.advancedInput && that.shortName != null && that.shortName.trim().length !== 0) {
        // Name was specified
        cloudEndpoint.shrinkSpecificUrl(that.longUrl.trim(), that.shortName.trim()).then(urlResult => {
          that.isProcessing = false
          if (urlResult === null || urlResult.status === 'error') {
            that.hasError = true
            if (urlResult != null) {
              that.errorMessage = urlResult.message
            }
          } else {
            that.shortUrl = shortUrlEndpoint + '/' + urlResult
          }
        })
      } else {
        // Name will be generated
        cloudEndpoint.shrinkUrl(that.longUrl.trim()).then(urlResult => {
          that.isProcessing = false
          if (urlResult === null || urlResult.status === 'error') {
            that.hasError = true
            if (urlResult != null) {
              that.errorMessage = urlResult.message
            }
          } else {
            that.shortUrl = shortUrlEndpoint + '/' + urlResult
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.input-mode {
  text-align: left;
}
.input-mode a {
  font-size: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/CreateUrl.vue